module.exports = __webpack_public_path__ + "img/box-square.49f8ffac.svg";